export const fetchScanStatusData = async (payload) => {
    //configure api url
    const apiUrl = global.config.premTrackingServiceUrl + "/cargoawbtracking/trackAirWaybillPieces"
            + "?air-waybill-prefix=" + payload.awbPrefix
            + "&air-waybill-number=" + payload.airWaybillNumber
            + "&air-waybill-create-date=" + payload.isoCreateDate;

    const response = await fetch(apiUrl, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'X-API-Key': global.config.apiKey
        }
    });

    if (!response.ok) {
        throw new Error('Something went wrong ...');
    }

    return await response.json();
};




// WEBPACK FOOTER //
// ./src/api/scanStatusDataApi.js